module.exports = __webpack_public_path__ + "static/media/rectangle-select.85d8f61c.svg";